import { isEmpty, isNil } from 'lodash';
import { API } from '@shared/types/api';

export function countCompletedSubformFields(
  components: API.AnyComponent[],
  data: Record<string, any>,
): number {
  const componentIds = isEmpty(components) ? [] : components.map(component => component.id);
  const keys = isNil(data) ? [] : Object.keys(data);
  let count = 0;
  for (const key of keys) {
    if (componentIds.includes(key) && hasAuditComponentValue(data[key])) {
      count += 1;
    }
  }
  return count;
}

function hasAuditComponentValue(value: any): boolean {
  if (isNil(value)) {
    return false;
  }
  return !isEmpty(value.tags) || (!isNil(value.checked) && value.checked) || !isEmpty(value.text);
}
